import axios from "axios";
import { useState } from "react";

import { getDataFromResponse } from "~/api/axiosUtils.ts";
import { generateEInvoiceFile } from "~/modules/billing/api/eInvoice/eInvoiceApiDispatchers.ts";

export const useEInvoiceDownload = (invoiceId: string) => {
	const [isGenerating, setIsGenerating] = useState(false);
	const [missingFields, setMissingFields] = useState<string[] | null>(null);

	const handleDownload = async () => {
		if (isGenerating) return;

		setIsGenerating(true);
		setMissingFields(null);
		try {
			const response = await generateEInvoiceFile(invoiceId);
			const fileInfo = getDataFromResponse(response);

			const link = document.createElement("a");
			link.href = fileInfo.downloadUrl;
			link.download = fileInfo.fileName;
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		} catch (error) {
			if (axios.isAxiosError(error) && error.response?.status === 422) {
				setMissingFields(error.response.data.errors ?? []);
				return;
			}
			console.error(error);
		} finally {
			setIsGenerating(false);
		}
	};

	return {
		handleDownload,
		isGenerating,
		missingFields,
	};
};